import React, { useState } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { apiConstants, getGeneric } from '../../../common/constants';
import { EDITED_DOC_TYPES, formatEditChange } from './editLog';

// "Invoice replaced · View old · View new" for the fixed documents changed in one appointment edit.
// The server picks the file from the edit log (awb + historyIndex + editIndex + docType + OLD/NEW).
export default function EditDocLinks({ changes, awbNumber, historyIndex, editIndex, sx }) {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState('');
    const docChanges = (changes || []).filter((c) => EDITED_DOC_TYPES[c.field]);
    if (docChanges.length === 0 || editIndex == null) return null;

    const open = async (field, version) => {
        const key = `${field}-${version}`;
        setLoading(key);
        try {
            const params = { awbNumber, docType: EDITED_DOC_TYPES[field], editIndex, version };
            if (historyIndex != null) params.historyIndex = historyIndex;
            const res = await getGeneric(apiConstants.APPOINTMENT_DELIVERY_DOC_URL, params);
            const url = res?.data?.responseObj?.url || res?.data?.url;
            if (url) window.open(url, '_blank', 'noopener');
            else enqueueSnackbar('Document URL missing', { variant: 'warning' });
        } catch (e) {
            enqueueSnackbar(e?.response?.data?.message || 'Failed to open document', { variant: 'error' });
        }
        setLoading('');
    };

    const linkSx = { fontSize: 11, ml: 0.75, cursor: 'pointer' };
    return (
        <Box sx={sx}>
            {docChanges.map((c) => (
                <Typography key={c.field} component='div' sx={{ fontSize: 11, color: '#555' }}>
                    {formatEditChange(c)}
                    {c.from && (
                        <Link component='button' type='button' sx={linkSx} disabled={loading === `${c.field}-OLD`}
                            onClick={() => open(c.field, 'OLD')}>View old</Link>
                    )}
                    {c.to && (
                        <Link component='button' type='button' sx={linkSx} disabled={loading === `${c.field}-NEW`}
                            onClick={() => open(c.field, 'NEW')}>View new</Link>
                    )}
                </Typography>
            ))}
        </Box>
    );
}
